import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getJobPostsByTerms } from "../../../actions/job";

import JobResultItem from "./JobResultItem";
import LocationResultItem from "./LocationResultItem";

const JobSearchInputs = ({
  getJobPostsByTermsByTerms,
  setRedirected,
  getJobPostsByTerms,
  jobs,
}) => {
  const [text, setText] = useState({ jobtitle: "", location: "" });

  useEffect(() => {
    getJobPostsByTerms(text);
  }, [text]);
  return (
    <Fragment>
      <div className="hero">
        <div className="job-search-container">
          <div className="main">
            <form
              className="form-flex"
              onSubmit={(e) => {
                e.preventDefault();
                if (text.jobtitle !== "" || text.location !== "") {
                  getJobPostsByTermsByTerms(text);
                  setText({ jobtitle: "", location: "" });
                }
              }}
            >
              <div className="label-input">
                <label htmlFor="jobsearch" className="labels green">
                  Job Title<i className="fas fa-search mx-5 green"></i>
                </label>
                <div className="input-drop-down">
                  <div className="search-input-hidden">
                    <input
                      className="search-input-style"
                      type="text"
                      name="text"
                      value={text.jobtitle}
                      onChange={(e) =>
                        setText({ ...text, jobtitle: e.target.value })
                      }
                      placeholder="Enter Job Title or Employer Name"
                    />
                  </div>
                  {text.jobtitle !== "" &&
                    jobs &&
                    jobs.length > 0 &&
                    jobs.map((job) => {
                      return <JobResultItem key={job._id} job={job} />;
                    })}
                </div>
              </div>
              <div className="label-input">
                <label htmlFor="joblocation" className="labels green">
                  Location<i className="fas fa-location-arrow green mx-5"></i>
                </label>
                <div className="input-drop-down">
                  <div className="search-input-hidden">
                    <input
                      className="search-input-style"
                      type="text"
                      name="locationtext"
                      value={text.location}
                      onChange={(e) =>
                        setText({ ...text, location: e.target.value })
                      }
                      placeholder="Enter City, State or Zip Code"
                    />
                    <button
                      className="search-button background-green"
                      onClick={(e) => {
                        e.preventDefault();
                        if (text.jobtitle !== "" || text.location !== "") {
                          getJobPostsByTermsByTerms(text);
                          setText({ jobtitle: "", location: "" });
                        }
                      }}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  {text.location !== "" &&
                    jobs &&
                    jobs.map((job) => {
                      return <LocationResultItem key={job._id} job={job} />;
                    })}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

JobSearchInputs.propTypes = {
  auth: PropTypes.object.isRequired,
  getJobPostsByTerms: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getJobPostsByTerms,
})(JobSearchInputs);
